/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/embed_styles';



/* ========== ~~~~~~~~~~ EMBED ~~~~~~~~~~ ========== */
const Embed = (props) => {
    return(
    	<div className={`embed ${props.classes.embed} editable-${props.isEditable} ${props.embedLocationType}`}>
            {props.children}
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Embed);
